import { FC } from 'react';
import classnames from 'classnames';
import { LayOutPageRightProps, LayOutPageItemEnum } from './interface';

const LayOutPageRight: FC<LayOutPageRightProps> = props => {
  const { children, className, ...restProps } = props;
  const classes = classnames('yb-layout-page-right', className);
  return (
    <div className={classes} {...restProps}>
      {children}
    </div>
  );
};

LayOutPageRight.displayName = LayOutPageItemEnum.Right;

export default LayOutPageRight;
